import { status } from "skin/event/status";
import { setAll, toggle } from "../toggling";
import api from "skin/http";
import config from "config_skin";
import { loadTrees } from "../loading";
import { pullAllChanges, cacheRows, clearCache, syncFlags } from "./cache";

const TABLE_NAME = "formExclusion";

export default function msFormEx(obj, ms, story, data, d, action) {
	const rows = data.curData.values.table.formExclusion?.list || [];

	if (obj.type === "table" && obj.action === "row") {
		const row = rows.find(({ key }) => key === obj.key);
		toggle(TABLE_NAME, data, rows, row);
		return status.ignore;
	}

	if (obj.action === "exit") clearCache();

	if (obj.action === "next") pullAllChanges(rows);

	if (obj.action === "setInput" && obj.name === "form") {
		cacheRows(rows);
		return api({
			method: "GET",
			url: `${config.url}api/exceptions/form?code=${obj.value}`,
		})
			.then(({ data: trees }) => loadTrees(TABLE_NAME, trees, data, ms))
			.catch(console.error)
			.then(() => {
				syncFlags(data);
				return status.action;
			});
	}

	if (obj.code === "all" || obj.code === "clear")
		setAll(TABLE_NAME, data, obj.code === "all");

	return status.action;
}
